module.exports = __webpack_public_path__ + "img/sdg14_jp.56c56b2f.png";